import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';
import EditComponent from '../../../_common/platform/tsx/CKEditField';

export default class CKEditField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(glob, title: string, validators?: any, defaultVal: string = '', options?) {
        super(glob, title, CKEditField.defaultValidators, validators, defaultVal, options);
    }
}
